import { useState, useEffect } from "react";
import IQImg from '../../images/NA.webp'


const handleImgClick = () => {
    window.open(' https://forms.gle/xXMQscQuErc4UFr8A', '_blank', 'noopener,noreferrer');
};

const paymentClick = () => {
    window.open('https://www.zeffy.com/en-CA/ticketing/vex-robotics-iq-summer-workshop-aug-121416-grd-3--8', '_blank', 'noopener,noreferrer');
}
const slideImages = [
    '../../images/aerial/1.jpg',
    '../../images/aerial/2.jpg',
    '../../images/aerial/3.jpg',
    '../../images/aerial/4.jpg',
    // Add more image paths as needed
];
export default function IQWorkshop() {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prevSlide => (prevSlide + 1) % slideImages.length);
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, []);
    
    return (
        <div className='flex flex-col items-center space-y-6'>
            <h1 className='text-center font-bold text-5xl mt-8'>VEX IQ Summer Workshop</h1>
            <div className='text-center px-6'>
                <p className='inline'>
                Mi3L School is offering an IQ Workshop for Grd 3-8!                
                </p>
                <p>
                 Aug 12th & 14th: 7-9PM, Aug 16th, 6-9PM
                </p>

                <p>
                    Location: 2A-1453 Cornwall Rd Oakville 
                </p>

            </div>
            <button 
        className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300'
        onClick={handleImgClick} // Add your onClick handler
    >
        Reserve a Spot
    </button>
            <img className='cursor-pointer' src={IQImg} onClick={handleImgClick} />
        <footer>
        <button 
        className='px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-300'
        onClick={paymentClick}
        
    >
        Make a payment
    </button>
        </footer>
        </div>
    )
}